import * as moment from "moment";

const milestoneState = (({self, today}) => {
  if (!self || !today || !self.date) {
    return self.complete ? "Complete" : "";
  }
  if (self.complete) return "Complete";
  try {
    const momentDate = moment.utc(self.date, "YYYY-MM-DD", true);
    if (momentDate.format() === "Invalid date") return "Invalid Date";
    return momentDate.isBefore(today) ? "Delayed" : "On Time";
  } catch (e) {
    return "Invalid Date";
  }
});

const milestoneSortOrder = (({self, today}) => {
  // 5 = delayed, 4 = invalid date 3 = on time 2 = no notion of now but not done 1 = complete
  if (!self || !today || !self.date) {
    return self.complete ? 1 : 2;
  }
  if (self.complete) return 1;
  try {
    const momentDate = moment.utc(self.date, "YYYY-MM-DD", true);
    if (momentDate.format() === "Invalid date") return 4;
    return momentDate.isBefore(today) ? 5 : 3;
  } catch (e) {
    return 4;
  }
});

const milestoneNgClass = (({row, today}) => {
  if (!row || !today || row.complete) return undefined;
  try {
    const date = moment.utc(row.date, "YYYY-MM-DD", true);
    if (date.format() === "Invalid date") return {"table-danger": true};
    return date.isBefore(today) ? {"table-danger": true} : undefined;
  } catch (e) {
    return {"table-danger": true};
  }
});

export const milestoneData = {
  generalData: {
    name: "milestones",
    editTitle: "Edit Dashboard Milestone",
    defaults: {
      editable: true,
      removable: true,
      newRowDefaults: {description: "", complete: false},
      ngClass: milestoneNgClass,
    },
    editable: true, // Allow to edit rows
    removable: true, // Allow to remove rows
    appendable: true, // Allow the user to add rows
    ordered: false, // Milestones are not ordered
    reorderable: false, // Allow altering of the order
    showLimit: false,
    sortOrder: {
      complete: {precedence: 1, order: "descending"},
      index: {precedence: 2, order: "descending"}, // Last in first out
    },
  },
  metadata: [
    {
      field: "description",
      sortable: true,
      name: "Description",
      type: "string",
      editable: true,
      searchable: true,
      required: true,
    },
    {
      field: "date",
      sortable: true,
      name: "Date",
      type: "date",
      editable: true,
      searchable: true,
      required: true,
    },
    {
      field: "complete",
      sortable: true,
      name: "Complete",
      type: "boolean",
      editable: true,
      searchable: true,
      values: [
        {value: false, name: "In progress"},
        {value: true, name: "Complete"}],
      stringFunctions: {
        display: milestoneState,
        sort: milestoneSortOrder,
      },
      required: true,
    },
  ],
};

const issuesNgClass = (({row, today}) => {
  if (!row || !today || row.action === "closed") return undefined;
  try {
    const dueDate = moment.utc(row.dueDate, "YYYY-MM-DD", true);
    if (dueDate.format() === "Invalid date") return {"table-danger": true};
    return dueDate.isBefore(today) ? {"table-danger": true} : undefined;
  } catch (e) {
    return {"table-danger": true};
  }
});

const issuesSortOrder = (({self, today}) => {
  // 5 = Open and late, 4 = invalid date 3 = on time 2 = no notion of now but not done 1 = closed
  if (!today || !self.dueDate || self.action === "closed") {
    return self.action === "closed" ? 1 : 2;
  }
  try {
    const dueDate = moment.utc(self.dueDate, "YYYY-MM-DD", true);
    if (dueDate.format() === "Invalid date") return 4;
    return dueDate.isBefore(today) ? 5 : 3;
  } catch (e) {
    return 4;
  }
});

export const dashboardIssuesData = {
  generalData: {
    name: "issues",
    editTitle: "Edit Dashboard Milestone",
    defaults: {
      editable: true,
      removable: true,
      newRowDefaults: {description: ""},
      ngClass: issuesNgClass,
    },
    editable: true, // Allow to edit rows
    removable: true, // Allow to remove rows
    appendable: true, // Allow the user to add rows
    showLimit: true,

    sortOrder: {
      action: {precedence: 1, order: "descending"}, // Default is open issues first
      dueDate: {precedence: 2, order: "ascending"}, // Followed by those due soonest
      openDate: {precedence: 3, order: "ascending"}, // Followed by those opened first
      index: {precedence: 4, order: "descending"}, // Lastly first entered
    },
  },
  metadata: [
    // NOTE: No true field may be named 'index' or self  because it has special meaning
    {
      field: "type",
      sortable: true,
      name: "Type",
      type: "dropbox",
      editable: true,
      searchable: true,
      values: [
        {value: "Issue", name: "Issue"},
        {value: "Risk", name: "Risk"},
        {value: "Decision", name: "Decision"}],
      required: true,
    }, {
      field: "id",
      sortable: true,
      name: "ID",
      type: "number",
      editable: true,
      searchable: true,
      required: true,
    }, {
      field: "description",
      sortable: true,
      name: "Description",
      type: "string",
      maxLength: 3000,
      editable: true,
      searchable: true,
      required: true,
    }, {
      field: "owner",
      sortable: true,
      name: "Owner",
      type: "string",
      maxLength: 100,
      editable: true,
      searchable: true,
      required: true,
    }, {
      field: "openDate",
      sortable: true,
      name: "Open Date",
      type: "date",
      editable: true,
      required: true,
      disableListDisplay: true,
    }, {
      field: "dueDate",
      sortable: true,
      name: "Due Date",
      type: "date",
      editable: true,
      required: true,
    }, {
      field: "action",
      sortable: true,
      name: "Status",
      type: "dropbox",
      values: [
        {value: "open", name: "Open"},
        {value: "closed", name: "Closed"}],
      editable: true,
      searchable: true,
      required: true,
      stringFunctions: {
        sort: issuesSortOrder,
      },
    },
  ],
};
